/**
 * Centralized react-query key factory.
 *
 * Why a single file: every cache write/read needs to use the same key shape,
 * otherwise we get silent miss-on-miss issues that are hard to debug.
 */
export const meKey = (): readonly ["me"] => ["me"] as const;
export const inboxKey = (): readonly ["inbox"] => ["inbox"] as const;
export const threadKey = (
  counterparty: string,
): readonly ["thread", string] => ["thread", counterparty] as const;
export const contactsKey = (): readonly ["contacts"] => ["contacts"] as const;
